import { render, staticRenderFns } from "./CambioMoldesCard.vue?vue&type=template&id=4ab94138&scoped=true&"
import script from "./CambioMoldesCard.vue?vue&type=script&lang=js&"
export * from "./CambioMoldesCard.vue?vue&type=script&lang=js&"
import style0 from "./CambioMoldesCard.vue?vue&type=style&index=0&id=4ab94138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab94138",
  null
  
)

export default component.exports